// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2XDHL","tab":"Tabs_tab__3Z2_8","tabActive":"Tabs_tabActive__2NyHx"};